module.exports = __webpack_public_path__ + "static/media/acompanhar-tecnico.57360828.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/acompanhar-tecnico.svg
// module id = 2834
// module chunks = 0